var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWestVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78 1.58039L6.6 0.400391L0 7.00039L6.6 13.6004L7.78 12.4204L2.36 7.00039L7.78 1.58039Z",
    fill: "#3399FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWestVector);
export default __webpack_public_path__ + "static/media/west_vector.b9afb164d7e40e99e872a0e94dbff399.svg";
export { ForwardRef as ReactComponent };